<template>
  <div class="cart-items">
    <div class="cart-items__list-wrapper">
      <ul v-if="cart.items.length" class="cart-items__list">
        <li v-for="item in cart.items" :key="item.id">
          <CartItem
            :item="item"
            @change="updateItem"
            @edit="editItem"
            @delete="openDeleteModal"
          />
        </li>
      </ul>
      <p v-else class="cart-items__no-items-msg">
        No items in the cart
      </p>
    </div>
    <SheetModal
      :item="currentItem"
      :is-open="sheetModalOpen"
      @edit="editItem"
      @update="updateSheet"
      @close="closeSheetModal"
    />
    <DeleteModal
      :item="currentItem"
      :is-open="deleteModalOpen"
      @delete="deleteItem"
      @close="closeDeleteModal"
    />
  </div>
</template>

<script>
import CartItem from './CartItem.vue';
import SheetModal from './SheetModal.vue';
import DeleteModal from './DeleteModal.vue';

import cartStore from '../../../vue-apps/stores/cart';

export default {
  props: {
    cart: {
      type: Object,
      required: true
    },
    editUrl: {
      type: String
    }
  },
  data() {
    return {
      currentItem: null,
      sheetModalOpen: false,
      deleteModalOpen: false
    };
  },
  watch: {
    cart: {
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const itemId = urlParams.get('itemId');
        if (itemId) {
          this.openSheetModalById(itemId);
        }
      },
      deep: true
    }
  },
  methods: {
    editItem(item) {
      if (item.metaData && item.metaData.isSheet) {
        this.openSheetModal(item);
      } else {
        const url = new URL(this.editUrl, document.baseURI);
        url.searchParams.append('designId', item.designs ? item.designs[0].designId : item.designId);
        window.location.href = url.toString();
      }
    },
    deleteItem(item) {
      this.performDelete(item);
    },
    updateItem(item, callback) {
      if (this.debounce) {
        clearTimeout(this.debounce);
      }
      this.debounce = setTimeout(() => {
        this.performUpdate(item, callback);
      }, 1000);
    },
    updateSheet(sheet, callback) {
      // get existing item
      const existing = this.cart.items.find(x => x.id === sheet.id);
      // update each design
      existing.designs.reduce((p, item) => {
        return p.then(() => {
          const updated = sheet.designs.find(x => x.id === item.id);
          return updated ? this.performUpdate(updated, callback) : this.performDelete(item);
        });
      }, Promise.resolve());
    },
    performUpdate(item, callback) {
      // update item
      return cartStore.update(item.id, item.quantity).then(res => {
        // execute callback if provided
        if (callback) {
          callback();
        }
      });
    },
    performDelete(item) {
      // remove item
      return cartStore.remove(item.id);
    },
    openSheetModal(item) {
      this.currentItem = item;
      this.sheetModalOpen = true;
    },
    openSheetModalById(id) {
      // find sheet by item or design ID
      const sheet = this.cart.items.find(x => {
        return x.metaData?.isSheet && (x.id == id || x.designs.some(y => y.designId == id));
      });
      // open sheet modal
      sheet && this.openSheetModal(sheet);
    },
    closeSheetModal() {
      this.sheetModalOpen = false;
      this.currentItem = null;
      // remove query string
      window.history.replaceState(null, '', window.location.pathname);
    },
    openDeleteModal(item) {
      this.currentItem = item;
      this.deleteModalOpen = true;
    },
    closeDeleteModal() {
      this.currentItem = null;
      this.deleteModalOpen = false;
    }
  },
  components: {
    CartItem,
    SheetModal,
    DeleteModal
  }
};
</script>
